import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import ProgressOverlay from "Components/progressOverlay";
import classNames from "classnames";
import filter from "lodash/filter";
import VirtualScrollList from "rc-virtual-list";
import { useResizeDetector } from "react-resize-detector";
import { Toolbar } from "./toolbar";
import { LogItem } from "./logItem";
import { LOG_LEVEL_VALUES } from "Common/dictionaries/logLevel/logLevel";
import styles from "./tasksLogs.inner.module.css";
const getItemKey = (item) => `${item.DateTime}_${item.LogLevel}_${item.Message}_${item.Id}`;
export default function TasksLogsInner({ documentId, logLevels, onSetLogLevels, onInitialized, data, inProgress, onClear, title, zIndex }) {
    const [levels, setLevels] = useState(() => logLevels || new Set(LOG_LEVEL_VALUES));
    const { height, ref: containerRef } = useResizeDetector();
    const listRef = useRef(null);
    const [readyToShow, setReadyToShow] = useState(false);
    const readyToShowRef = useRef(false);
    useEffect(() => {
        documentId && (onSetLogLevels === null || onSetLogLevels === void 0 ? void 0 : onSetLogLevels(levels, documentId));
    }, [documentId, levels, onSetLogLevels]);
    useEffect(() => {
        documentId && (onInitialized === null || onInitialized === void 0 ? void 0 : onInitialized(documentId));
    }, [documentId, onInitialized]);
    const filteredData = useMemo(() => {
        if (!data)
            return undefined;
        const result = filter(data, item => item && levels.has(item.LogLevel));
        return result.length ? result : undefined;
    }, [data, levels]);
    useEffect(() => {
        if (filteredData && filteredData.length && listRef.current) {
            listRef.current.scrollTo(filteredData.length);
            if (!readyToShowRef.current) {
                setTimeout(() => {
                    readyToShowRef.current = true;
                    setReadyToShow(true);
                }, 200);
            }
        }
    }, [filteredData]);
    const handleClear = useCallback(() => {
        documentId && (onClear === null || onClear === void 0 ? void 0 : onClear(documentId));
    }, [onClear, documentId]);
    return (React.createElement(ProgressOverlay, { show: inProgress },
        React.createElement("div", { className: classNames(styles.container, "overflow-hidden unselectable") },
            React.createElement(Toolbar, { title: title, onClear: onClear ? handleClear : undefined, levels: levels, onLevelsChange: setLevels, zIndex: zIndex }),
            React.createElement("div", { className: classNames(styles.content, "overflow-hidden"), ref: containerRef }, filteredData && (React.createElement(VirtualScrollList, { ref: listRef, className: classNames(!readyToShow && "invisible", "text-selectable"), data: filteredData, height: height !== null && height !== void 0 ? height : 0, itemKey: getItemKey }, (item, index) => item && (React.createElement(LogItem, { item: item, isFirst: index === 0, isLast: index === filteredData.length - 1 }))))))));
}
